$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});



$('.featured_tab').click(function(e){
e.preventDefault();
var current_tab = $(this).attr('data_tab');
$(this).parents('.shopify-section').find('.featured_tab').removeClass('active');
$(this).addClass('active');
$(this).parents('.shopify-section').find('.trigger_class_tabs').hide();
$(this).parents('.shopify-section').find('.trigger_class_tabs[data_tab="'+current_tab+'"]').show();
});


$(document).on("click", ".trigger_mobile_footer_dropdown h3", function (e) {
    //jQuery(this).toggleClass('active');
    //jQuery(this).next().slideToggle();
});
